'use client'

import {createContext} from 'react'

export interface FormContextProps {
	hasValidation: boolean
	isLoading: boolean
}

const FormContext = createContext<FormContextProps>({hasValidation: false, isLoading: false})

export default FormContext
